import { Box, Heading, Text, Divider, Flex, Link } from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  SettingsBreadcrumb,
  SettingsFacilitiesBreadcrumb,
} from './SettingsBreadcrumbs';
import { useCreditFacilityOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { colors } from '~/packages/common-frontend/colors';
import { Breadcrumbs } from '~/packages/common-frontend/components/Breadcrumbs';

type SettingsFacilityPortfolioCovenantsTemplateProps = {
  creditFacilityId: string;
  children: React.ReactNode;
};
export const SettingsFacilityPortfolioCovenantsTemplate = ({
  creditFacilityId,
  children,
}: SettingsFacilityPortfolioCovenantsTemplateProps) => {
  const creditFacility = useCreditFacilityOrThrow(creditFacilityId);
  const breadcrumbs = [
    SettingsBreadcrumb,
    SettingsFacilitiesBreadcrumb,
    { label: creditFacility.name },
    { label: 'Portfolio Covenants' },
  ];

  return (
    <Box p="40px">
      <Flex flexWrap={['wrap', 'wrap', 'wrap', 'nowrap']}>
        <Flex direction="column" flexGrow={1} flexShrink={0} maxWidth="100%">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <Heading as="h1" mt="16px" mb="16px" fontSize="36px" fontWeight={600}>
            Portfolio Covenants
          </Heading>
          <Text fontSize="16px" mb="16px" color={colors.black[70]}>
            Manage portfolio covenants for{' '}
            <Text as="span" fontSize="16px" mb="16px" fontWeight={500}>
              {creditFacility.name}.
            </Text>
          </Text>
        </Flex>
        <Flex direction="column">
          <Link
            color={colors.gray[500]}
            fontSize="0.75rem"
            as={RouterLink}
            to="./../../borrowing-base/configuration"
          >
            Go to Borrowing Base Settings
          </Link>
        </Flex>
      </Flex>
      <Divider />

      <Box mt="32px">{children}</Box>
    </Box>
  );
};
